﻿$.fn.dxCtrlHebergementSearch = function custom_dxCtrlHebergementSearch(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlhebergementsearch dx-ctrl");
        this.createInstance(new cdxCtrlHebergementSearch(this, option));
    }
    return this;
}

window.cdxCtrlHebergementSearch = function (container, option) {
    var Me = this;

    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    if (typeof option.nb_adulte == "undefined") option.nb_adulte = 2
    if (typeof option.nb_enfant == "undefined") option.nb_enfant = 0
    if (typeof option.nb_bebe == "undefined") option.nb_bebe = 0
    if (typeof option.date_debut == 'undefined') {
        option.date_debut = null
        option.date_fin = null
    }
    if (typeof option.lstReservationHebergement == 'undefined') option.lstReservationHebergement = []


    //var $DivLibDate = null
    var $DivLst = null
    var jauge = null
    this.dxCalendar = null
    function mConstruit() {
        container.empty();
        jauge = $("<div/>").appendTo(container).dxCtrlJauge({}).dxCtrlJauge("instance")

        $("<div style='white-space:nowrap;margin:10px;'/>").appendTo(container).dxCtrlGetNbPersonne({
            bddCtrl: option.bddCtrl,
            value: {
                nb_adulte: option.nb_adulte,
                nb_enfant: option.nb_enfant
            },
            onValueChanged: function (e) {
                option.nb_adulte = e.value.nb_adulte
                option.nb_enfant = e.value.nb_enfant
                mRempliCalendar()
                mUpdateList()
            }
        })

        //$DivLibDate = $("<div style='text-align:center;margin-top:20px;font-size:140%;'/>").appendTo(container)
        var $DivDate = $("<div/>").appendTo(container)
        mRempliCalendar()
        var valueDate = null //save les dates
        function mRempliCalendar() {
            $DivDate.css("height", $DivDate.innerHeight() + "px")
            $DivDate.empty()
            Me.dxCalendar = $("<div style='margin:5px " + (parametre.isPhone ? "0" : "20px") + ";'/>").appendTo($DivDate).dxCtrlCalendarInterval({
                selectedDates: option.selectedDates,
                value: (valueDate ? valueDate : option.dateVisu),
                selectedDates: option.selectedDates,
                height: (parametre.isPhone ? 280 : 330),
                width: (parametre.isPhone ? "100%" : 330),
                min: (option.forInternetExterne ? (new Date()).addDays(0) : (new Date()).addDays(-365)),
                showVacances: option.showVacances,
                lstDateOccup: option.bddCtrl.getObjet("hebergement").objetMetier.mGetLstDateOccupationAll(option.nb_adulte + option.nb_enfant, (option.forInternetExterne ? option.bddCtrl.paraAppli.mGetPara("hebergement_taux_occupation_minimale_internet") : null)),
                onValueChanged: function (ee) {
                    option.selectedDates = ee.selectedDates
                    var heureArrive = option.bddCtrl.paraAppli.mGetPara("hebergement_heure_arrivee_depart").arrivee
                    if (dxHeureArrive) heureArrive = dxHeureArrive.option("value")
                    var heureDepart = option.bddCtrl.paraAppli.mGetPara("hebergement_heure_arrivee_depart").depart
                    if (dxHeureDepart) heureDepart = dxHeureDepart.option("value")
                    option.selectedDates.date_debut = new Date((new Date(ee.selectedDates.date_debut)).setHours(heureArrive));
                    option.selectedDates.date_fin = new Date((new Date(ee.selectedDates.date_fin)).setHours(heureDepart));
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.selectedDates)
                    //mUpdateLibDate()
                    mUpdateList()
                    valueDate = ee.selectedDates.date_debut
                }
            }).dxCtrlCalendarInterval("instance")
            $DivDate.css("height", "")
        }
        var dxHeureArrive = null
        var dxHeureDepart = null
        if (option.showSelectHeure) {
            var $Table = $("<table style='width:100%;'/>").appendTo(container)
            var $Tr = $("<tr/>").appendTo($Table)
            var $Td = $("<td style='text-align:center;'/>").appendTo($Tr)
            dxHeureArrive = $("<div/>").appendTo($Td).dxCtrlHeureBox({
                textLink: "Arrivée à %%heure%% heure",
                value: option.bddCtrl.paraAppli.mGetPara("hebergement_heure_arrivee_depart").arrivee,
                onClick: function () {
                    if (option.selectedDates) { return true }
                    else {
                        mNotify("Veuillez sélectionner vos dates de séjour avant de modifier les heures d'arrivée et de départ", "error", 6000)
                        return false
                    }
                },
                onValueChanged: function (value) {
                    let d = option.selectedDates.date_debut;
                    d.setHours(value);
                    option.selectedDates.date_debut = new Date(d);
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.selectedDates)
                    //mUpdateLibDate()
                    mUpdateList()
                }
            }).dxCtrlHeureBox("instance")
            var $Td = $("<td style='text-align:center;'/>").appendTo($Tr)
            dxHeureDepart = $("<div/>").appendTo($Td).dxCtrlHeureBox({
                textLink: "Départ à %%heure%% heure",
                value: option.bddCtrl.paraAppli.mGetPara("hebergement_heure_arrivee_depart").depart,
                onClick: function () {
                    if (option.selectedDates) { return true }
                    else {
                        mNotify("Veuillez sélectionner vos dates de séjour avant de modifier les heures d'arrivée et de départ", "error", 6000)
                        return false
                    }
                },
                onValueChanged: function (value) {
                    let d = option.selectedDates.date_fin;
                    d.setHours(value);
                    option.selectedDates.date_fin = new Date(d);
                    if (typeof option.onValueChanged != 'undefined') option.onValueChanged(option.selectedDates)
                    //mUpdateLibDate()
                    mUpdateList()
                }
            }).dxCtrlHeureBox("instance")
        } else {
            if (option.forInternetExterne) {
                $("<div style='font-family:barlow condensed;text-align:center;'/>").appendTo(container).text("Les arrivées se font entre " + option.bddCtrl.paraAppli.mGetPara("hebergement_période_arrivee_depart").arrivee[0] + "h et " + option.bddCtrl.paraAppli.mGetPara("hebergement_période_arrivee_depart").arrivee[1] + "h")
                $("<div style='font-family:barlow condensed;text-align:center;'/>").appendTo(container).text("Précisez dans le commentaire du panier si vous avez des horaires particuliers")
            }
        }


        $DivLst = $("<div style='margin:3px;padding:3px;'/>").appendTo(container)

        //mUpdateLibDate()
        mUpdateList()
    }

    //function mUpdateLibDate() {
    //    if (!option.selectedDates) {
    //        $DivLibDate.text("Sélectionnez les dates du séjour")
    //    } else {
    //        var nbNuit = mGetNbNuits(option.selectedDates.date_debut, option.selectedDates.date_fin)
    //        $DivLibDate.html(mGetLibDateHtml() + " • " + nbNuit + " nuité" + (nbNuit > 1 ? "s" : ""));
    //    }
    //}

    function mGetLibDateHtml() {
        var libHtml = ""
        var dateMin = option.selectedDates.date_debut
        var dateMax = option.selectedDates.date_fin
        if (dateMin.getFullYear() == dateMax.getFullYear()) {
            if (dateMin.getMonth() == dateMax.getMonth()) {
                if (dateMin.getDate() == dateMax.getDate()) {
                    var format = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
                    libHtml += "<b>" + dateMin.dayOfWeekName() + " " + format(dateMin) + "</b>"
                } else {
                    var formatDepart = d => DevExpress.localization.formatDate(d, "dd");
                    var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
                    libHtml += "<b>" + dateMin.dayOfWeekName() + " " + formatDepart(dateMin) + "</b>→<b>" + dateMax.dayOfWeekName() + " " + formatArrive(dateMax) + "</b>"
                }
            } else {
                var formatDepart = d => DevExpress.localization.formatDate(d, "dd/MM");
                var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yyyy");
                libHtml += "<b>" + dateMin.dayOfWeekName() + " " + formatDepart(dateMin) + "</b>→<b>" + dateMax.dayOfWeekName() + " " + formatArrive(dateMax) + "</b>"
            }
        } else {
            var formatDepart = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
            var formatArrive = d => DevExpress.localization.formatDate(d, "dd/MM/yy");
            libHtml += "<b>" + dateMin.dayOfWeekName() + " " + formatDepart(dateMin) + "</b>→<b>" + dateMax.dayOfWeekName() + " " + formatArrive(dateMax) + "</b>"
        }
        return libHtml
    }

    function mUpdateList() {
        $DivLst.empty()
        if (option.selectedDates && option.nb_adulte + option.nb_enfant > 0) {
            var lstIdTableId = []
            var lst = option.bddCtrl.getObjet("hebergement").objetMetier.mGetLstHebergementLibreWithTxOccup(option.selectedDates.date_debut, option.selectedDates.date_fin, option.nb_adulte + option.nb_enfant, option.dataReservationEnCours).sort(function (o1, o2) {
                return parseInt(o2.taux_occupation) - parseInt(o1.taux_occupation)
            })

            if (option.forInternetExterne) {
                lst.forEach(function (dataHebergOccup) {
                    if (dataHebergOccup.hebergement.dispo_internet == "1") {
                        if (lstIdTableId.length < option.bddCtrl.paraAppli.mGetPara("hebergement_internet_nb_hebergement_max_propose")) {
                            if (dataHebergOccup.taux_occupation >= option.bddCtrl.paraAppli.mGetPara("hebergement_taux_occupation_minimale_internet")) {
                                lstIdTableId.push({ id_table: option.bddCtrl.table.mGetItemFromNom("hebergement").id_table, id: dataHebergOccup.hebergement.id_hebergement })
                            }
                        }
                    }
                })
            } else {
                lst.forEach(function (dataHebergOccup) {
                    lstIdTableId.push({ id_table: option.bddCtrl.table.mGetItemFromNom("hebergement").id_table, id: dataHebergOccup.hebergement.id_hebergement })
                })
            }

            if (lstIdTableId.length > 0) {
                var $DivLib = $("<div style='padding:5px;text-align:center;font-size:140%;'>" + lstIdTableId.length + " hébergement" + (lstIdTableId.length > 1 ? "s" : "") + " trouvé" + (lstIdTableId.length > 1 ? "s" : "") + " du " + mGetLibDateHtml() + "</div>").appendTo($DivLst)
                var $I = $("<i class='fas fa-arrow-rotate-left dx-theme-accent-as-text-color state-hover' style='font-size:140%;margin-left:5px;border-radius:50%;'></i>").appendTo($DivLib)
                $I.on("click", function () {
                    option.selectedDates = null
                    mConstruit()
                })
                option.bddCtrl.mAjaxCall({
                    command: "getlstdatavirtualgrid",
                    data: lstIdTableId
                }, function (data) {
                    if (typeof data.lstdatatemplate == 'undefined') data.lstdatatemplate = []
                    data.lstdatatemplate.forEach(function (dataHebergTemplate) {
                        var $Table = $("<table style='margin:15px 5px;padding:5px;border:" + theme.border + ";box-shadow: 0 0 10px 1px rgba(0, 0, 0, 0.5);table-layout:fixed;width:100%;' class='state-hover-color'/>").appendTo($DivLst)
                        var $Tr = $("<tr/>").appendTo($Table)
                        var $Td = $("<td style='width:100%;vertical-align:top;'/>").appendTo($Tr)
                        if (parametre.isPhone) {
                            option.bddCtrl.getObjet("hebergement").itemTemplateGrille($Td, dataHebergTemplate, "Lignes", {
                                contentTemplateRight: function (contentElement) {
                                    mRempliChoisir(contentElement)
                                }
                            })
                        } else {
                            option.bddCtrl.getObjet("hebergement").itemTemplateGrille($Td, dataHebergTemplate, "Lignes")
                            var $Td = $("<td style='width:1px;vertical-align:top;text-align:center;width:120px;'/>").appendTo($Tr)
                            mRempliChoisir($Td)
                        }

                        function mRempliChoisir(contentElement) {
                            $("<div class='btchoisir'/>").appendTo(contentElement).dxCtrlButton({
                                text: "Choisir",
                                onClick: function (e) {
                                    //var config = option.bddCtrl.getObjet("hebergement", dataHebergTemplate.id_key).objetMetier.mGetLstBestHebergementConfigWithAdulteEnfant(option.nb_adulte, option.nb_enfant)[0]
                                    option.onSelectHebergement({
                                        selectedDates: option.selectedDates,
                                        idHebergement: dataHebergTemplate.id_key,
                                        nb_adulte: option.nb_adulte,
                                        nb_enfant: option.nb_enfant,
                                        //nb_grand_lit: config.nb_grand_lit,
                                        //nb_petit_lit: config.nb_petit_lit
                                    })
                                }
                            })
                            var totTtc = option.bddCtrl.getObjet("hebergement", dataHebergTemplate.id_key).objetMetier.mGetPrixSurPeriode(option.selectedDates.date_debut, option.selectedDates.date_fin, option.nb_adulte + option.nb_enfant)

                            $("<div style='text-align:center;padding:5px;'/>").appendTo(contentElement).append("<span>" + parseFloat(totTtc).formatDisplay() + "€</span>")
                        }

                    })
                })
            } else {
                $DivLst.html("<div style='text-align:center;font-size:140%;'>Aucun hébergement disponible du " + mGetLibDateHtml() + "</div>")
            }
        } else {
            $DivLst.html("<div style='text-align:center;font-size:140%;'>Aucun hébergement - veuillez sélectionner des dates</div>")
            if (option.nb_adulte + option.nb_enfant == 0) {
                mNotify("Veuillez choisir un nombre d'adulte ou d'enfant", "error", 6000)
            }
        }
    }

    this.element = function () { return container; }
    this.component = function () { return dx; }

    mConstruit();

}